// extracted by mini-css-extract-plugin
module.exports = {"container":"container--fdVQZEFgli8HtpL1M66z"};